import { useState, useEffect } from 'react';
import { Configuration } from '../assets/data/config'; 

export const useLocaleConfiguration = (source = 'default') => {
    const [config, setConfig] = useState(() => {
        const cachedConfig = localStorage.getItem('appConfign');
        if (cachedConfig) {
            console.log("CACHED")
            localStorage.removeItem('appConfign'); 
            return JSON.parse(cachedConfig); 
        }
        return null;
    });
    const [loading, setLoading] = useState(!config);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!config) {  
            setLoading(true);
            fetch(`${Configuration.apiService.key}dataStore/ruleConfig/countyrule`, {
                headers: {
                    'Authorization': 'Basic UmVhZE9ubHlVc2VyOlRlc3RAMTIz',  
                    'Cache-Control': 'no-cache'
                }
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch configuration');
                }
                return response.json();
            })
            .then(data => {
                console.log("DATAAPI",data)
                localStorage.setItem('appConfign', JSON.stringify(data));
                sessionStorage.removeItem('appConfign');
                sessionStorage.setItem('appConfign',JSON.stringify(data))
                console.log(data)
                setConfig(data);
            })
            .catch(err => {
                setError(err.message);
            })
            .finally(() => {
                setLoading(false);
            });
        }
    }, []); 

    return { config, loading, error };
};
